import { databases } from "@/lib/appwrite"
import { ID, Query } from "appwrite"
import type { Models } from "appwrite"

const DB = import.meta.env.VITE_BLOCKCHAIN_DATABASE_ID
const COL = import.meta.env.VITE_BLOCKCHAIN_INSTRUMENT_AUDIT_LOG_COLLECTION_ID

export interface AuditLogEntry extends Models.Document {
    instrumentId: string
    userId: string
    userName: string
    field: string
    previousValue: string
    newValue: string
    changedAt: string
}

export const FIELD_LABELS: Record<string, string> = {
    status: "Estado",
    equipmentName: "Nombre del equipo",
    model: "Modelo",
    location: "Ubicación",
    equipmentType: "Tipo de equipo",
    voltage: "Voltaje",
    current: "Corriente",
    clientAssetCode: "Código activo cliente",
    equipmentDescription: "Descripción",
    idOrganization: "Organización",
    idBrand: "Marca",
    additionalEquipment: "Equipo adicional",
    idFiles: "Imágenes",
    credentials: "Credenciales",
}

export const STATUS_LABELS: Record<string, string> = {
    operativo:               "Operativo",
    operativo_observaciones: "Operativo con observaciones",
    fuera_servicio:          "Fuera de servicio",
}

export const EQUIPMENT_TYPE_LABELS: Record<string, string> = {
    farmaceutico: "Farmacéutico",
    industrial: "Industrial",
    medico: "Médico",
    alimentos_bebidas: "Alimentos y Bebidas",
    laboratorio: "Laboratorio",
    mineria: "Minería",
    construccion: "Construcción",
    ambiental: "Ambiental",
    otro: "Otro",
}

export const resolveValue = (field: string, raw: string): string => {
    if (!raw) return "—"
    if (field === "status") return STATUS_LABELS[raw] ?? raw
    if (field === "equipmentType") return EQUIPMENT_TYPE_LABELS[raw] ?? raw
    if (field === "idFiles") return `${raw} ${raw === "1" ? "imagen" : "imágenes"}`
    if (field === "idOrganization" || field === "idBrand") return "actualizado"
    if (field === "additionalEquipment") {
        const items = raw.split("|").filter(Boolean)
        return items.length === 0 ? "ninguno" : items.join(", ")
    }
    return raw
}

export const logInstrumentChanges = async (
    instrumentId: string,
    userId: string,
    userName: string,
    changes: { field: string; previousValue: string; newValue: string }[]
): Promise<void> => {
    if (changes.length === 0) return
    const changedAt = new Date().toISOString()
    await Promise.all(
        changes.map(({ field, previousValue, newValue }) =>
            databases.createDocument(DB, COL, ID.unique(), {
                instrumentId,
                userId,
                userName,
                field,
                previousValue,
                newValue,
                changedAt,
            })
        )
    )
}

export const getInstrumentAuditLog = async (instrumentId: string): Promise<AuditLogEntry[]> => {
    const res = await databases.listDocuments(DB, COL, [
        Query.equal("instrumentId", instrumentId),
        Query.orderDesc("changedAt"),
        Query.limit(100),
    ])
    return res.documents as unknown as AuditLogEntry[]
}
